import React, { useState } from 'react';
import { ClipLoader } from 'react-spinners';
import { usePageStatistics } from '../../hooks/usePageStatistics';
import useApiAction from '../../hooks/useApiAction';
import HierarchySection from './HierarchySection';
import './PageStatisticsModal.scss';

const PageStatisticsModal = ({ contentId, contentType, onClose }) => {
  const {
    summary,
    details,
    isSummaryLoading,
    summaryError,
    loadingDetailsType,
    detailsError,
    loadDetailsForType,
    refreshSummary,
  } = usePageStatistics(contentId, contentType);

  const {
    performAction: performAnalysis,
    isLoading: isProcessing,
    error: processingError,
    data: analysisResult,
  } = useApiAction();

  const [showCloseWarning, setShowCloseWarning] = useState(false);

  const handleAnalyzeAndPublish = async () => {
    const result = await performAnalysis({
      url: '/admin/dashboard/prepare_and_publish',
      body: { id: contentId },
    });
    if (result) {
      await refreshSummary();
    }
  };

  const handleClose = () => {
    if (isProcessing) {
      setShowCloseWarning(true);
    } else {
      onClose();
    }
  };

  const renderContent = () => {
    if (isSummaryLoading) {
      return (
        <div className="spinner-container">
          <ClipLoader color="#007ACC" size={40} />
          <span>Lade Übersicht...</span>
        </div>
      );
    }
    if (summaryError) {
      return (
        <p className="status-message error" role="alert">
          {summaryError.message}
        </p>
      );
    }
    if (summary) {
      return (
        <>
          <HierarchySection summary={summary} />
        </>
      );
    }
    return null;
  };

  return (
    <div
      className="modal-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="modal-title"
    >
      <div className="modal-content">
        <button
          onClick={handleClose}
          className="modal-close-button"
          aria-label="Schließen"
        >
          &times;
        </button>
        <h2 id="modal-title" className="modal-title">
          Statistiken (
          {contentType.charAt(0).toUpperCase() + contentType.slice(1)})
        </h2>

        <button
          onClick={handleAnalyzeAndPublish}
          disabled={isProcessing || isSummaryLoading}
          className="modal-analyze-button"
        >
          {isProcessing ? (
            <>
              <ClipLoader color="white" size={20} />
              <span>Analysiere...</span>
            </>
          ) : (
            'Asset Analyse starten'
          )}
        </button>

        {isProcessing && (
          <p className="status-message info">
            Analyse wird gestartet...
            <span>
              Dieser Vorgang kann einige Minuten dauern. Sie können dieses
              Fenster schließen, die Analyse wird im Hintergrund abgeschlossen.
            </span>
          </p>
        )}
        {processingError && (
          <p className="status-message error" role="alert">
            Analyse fehlgeschlagen: {processingError.message}
          </p>
        )}
        {analysisResult && (
          <p className="status-message success">{analysisResult.message}</p>
        )}

        {showCloseWarning && (
          <div className="close-warning">
            <p>
              <strong>Warnung: Die Analyse läuft noch!</strong>
            </p>
            <p>
              Der Prozess wird im Hintergrund fortgesetzt. Möchten Sie das
              Fenster wirklich schließen?
            </p>
            <div className="button-group">
              <button
                onClick={() => setShowCloseWarning(false)}
                className="btn-secondary"
              >
                Abbrechen
              </button>
              <button onClick={onClose} className="btn-danger">
                Trotzdem schließen
              </button>
            </div>
          </div>
        )}

        {renderContent()}
      </div>
    </div>
  );
};

export default PageStatisticsModal;
